<template>
  

  <div class="grid">
    <loading
    :active="isLoadingModel"
    :can-cancel="true"
    color="#173EA3"
    :is-full-page="fullPage"
  ></loading>
    <div class="col-12">
      <div class="card">
        <!-- {{ getBreadcrummultiple }} -->
        <!-- {{ breadcrumbItems }} -->
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />

          <div class="p-fluid formgrid grid" style="margin-top: 2%">
             
            <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText  format="text"  v-model="owner_driver_name"  > </InputText>
                  <label>Owner/Driver name</label>
                </span>
              </div>

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText  format="number"  v-model="reg_number"  > </InputText>
                  <label>Registration Number</label>
                </span>
              </div>

              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText maxlength="10" format="text"  v-model="mob_number" onkeypress="return event.charCode >= 48 && event.charCode <= 57"> </InputText>
                  <label>Mobile Number</label>
                </span>
              </div>
             
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                    <Dropdown       id="User" 
                                    filter
                                    v-model="vehicle_dropdownItem" 
                                    :options="vehicle_dropdownItems" 
                                    optionLabel="name"
                                    >
                      </Dropdown>
                      <label for="vehicle_type">Vehicle Type</label>
                </span>
              </div>

              <div class="field col-12 md:col-2" v-if="showFirstFilter">
                <span class="p-float-label">
                  <MultiSelect 
                    id="state" 
                    filter 
                    v-model="vehicle_status" 
                    :options="vehicle_status_dropdown" 
                    optionLabel="name" 
                    :optionValue="name"
                    ></MultiSelect>
                <label for="Status">Status</label>
                </span>
              </div>

            <div class="field col-12 md:col-2"  v-if="user_key && (client_group_ids)">
              <span class="p-float-label">
                <MultiSelect id="state" filter  v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code" @change="get_vehicle_type_master"></MultiSelect>
                <label for="client">Select Client</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="district" filter v-model="district_dropdownItem" :options="district_dropdownItems"
                    optionLabel="name" @change="getBlockData">
                  </MultiSelect>
                <label for="district">District</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="block" filter v-model="block_dropdownItem" :options="block_dropdownItems"
                    optionLabel="name" @change="getPanchayatData">
                  </MultiSelect>
                <label for="block">Block</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="panchayat" filter v-model="panchayat_dropdownItem" :options="panchayat_dropdownItems"
                    optionLabel="name" @change="getVillageData(1)">
                  </MultiSelect>
                <label for="panchayat">Panchayat</label>
              </span>
            </div>

            <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                  <MultiSelect id="village" filter v-model="village_dropdownItem" :options="village_dropdownItems"
                    optionLabel="name" @filter="getVillageData">
                  </MultiSelect>
                <label for="village">Village</label>
              </span>
            </div>&nbsp;
              
              <div class="field col-2 md:col-2">
                <Button v-if="!showFirstFilter" style="color: white; background: 
        lightgreen; border: none" icon="pi pi-ellipsis-h" @click="show_filter()"  v-tooltip.bottom="'more'" />&nbsp;
                <Button
                  icon="pi pi-search"
                  v-tooltip.bottom="'Search'"
                  @click="search(1)"
                />&nbsp;
                <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
                <!-- <button v-if="!showFirstFilter" style="color: blue; background: none; border: none" @click="show_filter()">
                   more ...
                </button> -->
               
              </div>
              
         </div>
         

         
         <DataView :value="products" :layout="layout" :rows=rows>
          <template #empty>
            <div class="text-center">
              <b style="text-align:center">No records found.</b>
            </div>
          </template>

          <template #header>
            <div class=" flex flex-column md:flex-row md:justify-content-between md:align-items-center ">
              <h5 class="m-0"><b> Vehicle Master</b></h5>
              <div>
              
                <!-- <Button icon="pi pi-plus" class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
                  v-tooltip.bottom="'Add'" @click="openNew" /> -->
                  <Button  class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
                  v-tooltip.bottom="'Generate QR'" @click="GenerateQr" >Generate QR</Button>
                  <!-- <Button icon="pi pi-refresh" @click="search(2)"
                  style="background-color: #349CE4; border: 1px solid #349CE4;" v-tooltip.bottom="'Refresh'" /> -->
              </div>
            </div>
            <div style="text-align:right;font-weight:bold;margin-top: 1%;"><span>Total Vehicles:</span>{{ totalRecords }}</div>
          </template>
          <template #grid="slotProps">
            <div class="grid grid-nogutter" v-if="slotProps.items">
              <div class="col-12 md:col-3 xs:col-3" v-for="(item, index) in slotProps.items">
                <div class="card m-3 border-1 surface-border zoom card-hover" style="background-color: #F8F9FA">
                  <p v-if="item.status == 'Active' || item.status == 'active'">
                    <badge :value=item.status severity="success"></badge>
                  </p>
                  <p v-else-if="item.status == 'InActive' || item.status == 'In Active'">
                    <badge :value=item.status severity="warning"></badge>
                  </p>
                  <p v-else-if="item.status == 'Delete' || item.status == 'Deleted'">
                    <badge :value=item.status severity="danger"></badge>
                  </p>

                  <div class="text-center">
                    <div class="image-wrapper">
                      <img v-if="item.photos && item.photos[0]" :src="item.photos[0]"
                        class="my-4 md:my-0 w-9 md:w-8rem shadow-2 shadow-2" :alt="Image" style="border-radius: 10px;height: 100%;" >
                      <img v-else
                        src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                        class="my-4 md:my-0 w-8 md:w-5rem shadow-2  shadow-2" />
                    </div>

                    <div class="grid nested-grid">
                      <div class="col-8">
                        <div class="grid">
                          <div class="col-12">
                            <div class="text-left  font-bold">
                              <div v-if="item.registration_number" class="font-bold text-md">
                                <p>{{ item.registration_number }}</p>
                              </div>
                              <div v-else class="font-bold text-md">
                                <p>--</p>
                              </div>
                              <div v-if="item.vehicle_type" class="font-bold text-lg">
                                <p>{{ item.vehicle_type }}</p>
                              </div>
                              <div v-else class="font-bold text-lg">
                                <p>--</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center p-1 h-full">
                          <img :src="'images/scanner_sample.png'" class="clickable" @click="showQr(item)" :alt="Scanner"
                            style="cursor: pointer; width: 50px; height: 50px ">
                        </div>
                      </div>
                    </div>


                    <div class="grid">
                      <div class="col-4 text-left">
                        <p style="font-size: 12px; font-weight: 500; color: grey;margin-bottom: 5%;">Beacon </p>
                      </div>
                      <div class="col-8 text-left">
                        <p class=" clickable" @click="viewDevices(item)" v-tooltip.bottom="'Device List'"
                          style="color: blue; cursor: pointer; height: 7px; border: 1px solid white;">: {{
                          item.device_count }}</p>
                      </div>
                    </div>

                  </div>
                  <div class="flex align-items-center justify-content-between mt-3">
                    <Button icon="pi pi-eye" v-tooltip.bottom="'View'" class="p-button-rounded p-button-primary ml-2" @click="viewProduct(item)">
                    </Button>

                    <Button v-if="item.approval_flag && item.approval_flag==1" icon="pi pi-lock" v-tooltip.bottom="'Vehicle Lock'" class="p-button-rounded p-button-danger ml-2" @click="lock_Unlock(item,1)">
                    </Button>
                    <Button v-else icon="pi pi-lock-open" v-tooltip.bottom="'Vehicle Unlock'" class="p-button-rounded p-button-success ml-2" @click="lock_Unlock(item,2)">
                    </Button>

                    <Button icon="pi pi-pencil" v-tooltip.bottom="'Edit'" class="p-button-rounded p-button-warning p-component ml-2"
                      @click="editProduct(item)">
                    </Button>

                    <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'" class="p-button-rounded p-button-danger ml-2"
                      @click="confirmDeleteProduct(item)">
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-4" v-else>
              <div class="card m-3 border-1 surface-border zoom card-hover" style="background-color: #F8F9FA">
                  <p v-if="slotProps.data.status == 'Active' || slotProps.data.status == 'active'">
                    <badge :value=slotProps.data.status severity="success"></badge>
                  </p>
                  <p v-else-if="slotProps.data.status == 'InActive' || slotProps.data.status == 'In Active'">
                    <badge :value=slotProps.data.status severity="warning"></badge>
                  </p>
                  <p v-else-if="slotProps.data.status == 'Delete' || slotProps.data.status == 'Deleted'">
                    <badge :value=slotProps.data.status severity="danger"></badge>
                  </p>

                  <div class="text-center">
                    <div class="image-wrapper">
                      <img v-if="slotProps.data.photos && slotProps.data.photos[0]" :src="slotProps.data.photos[0]"
                        class="my-4 md:my-0 w-9 md:w-8rem shadow-2 shadow-2" :alt="Image" style="border-radius: 10px;height: 100%;" >
                      <img v-else
                        src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                        class="my-4 md:my-0 w-8 md:w-5rem shadow-2  shadow-2" />
                    </div>

                    <div class="grid nested-grid">
                      <div class="col-8">
                        <div class="grid">
                          <div class="col-12">
                            <div class="text-left  font-bold">
                              <div v-if="slotProps.data.registration_number" class="font-bold text-md">
                                <p>{{ slotProps.data.registration_number }}</p>
                              </div>
                              <div v-else class="font-bold text-md">
                                <p>--</p>
                              </div>
                              <div v-if="slotProps.data.vehicle_type" class="font-bold text-lg">
                                <p>{{ slotProps.data.vehicle_type }}</p>
                              </div>
                              <div v-else class="font-bold text-lg">
                                <p>--</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="text-center p-1 h-full">
                          <img :src="'images/scanner_sample.png'" class="clickable" @click="showQr(slotProps.data)" :alt="Scanner"
                            style="cursor: pointer; width: 50px; height: 50px ">
                        </div>
                      </div>
                    </div>


                    <div class="grid">
                      <div class="col-4 text-left">
                        <p style="font-size: 12px; font-weight: 500; color: grey;margin-bottom: 5%;">Beacon </p>
                      </div>
                      <div class="col-8 text-left">
                        <p class=" clickable" @click="viewDevices(slotProps.data)" v-tooltip.bottom="'Device List'"
                          style="color: blue; cursor: pointer; height: 7px; border: 1px solid white;">: {{
                          slotProps.data.device_count }}</p>
                      </div>
                    </div>

                  </div>
                  <div class="flex align-items-center justify-content-between mt-3">
                    <Button icon="pi pi-eye" v-tooltip.bottom="'View'" class="p-button-rounded p-button-primary ml-2" @click="viewProduct(slotProps.data)">
                    </Button>

                    <Button v-if="slotProps.data.approval_flag && slotProps.data.approval_flag==1" icon="pi pi-lock" v-tooltip.bottom="'Vehicle Lock'" class="p-button-rounded p-button-danger ml-2" @click="lock_Unlock(slotProps.data,1)">
                    </Button>
                    <Button v-else icon="pi pi-lock-open" v-tooltip.bottom="'Vehicle Unlock'" class="p-button-rounded p-button-success ml-2" @click="lock_Unlock(slotProps.data,2)">
                    </Button>

                    <Button icon="pi pi-pencil" v-tooltip.bottom="'Edit'" class="p-button-rounded p-button-warning p-component ml-2"
                      @click="editProduct(slotProps.data)">
                    </Button>

                    <Button icon="pi pi-trash" v-tooltip.bottom="'Delete'" class="p-button-rounded p-button-danger ml-2"
                      @click="confirmDeleteProduct(slotProps.data)">
                    </Button>
                  </div>
                </div>
            </div>
          </template>
        </DataView>
        <div class="pageno">
          <Paginator :rows="rows" :totalRecords="totalRecords" :rowsPerPageOptions="[6, 9, 24, totalRecords]"
            @page="onPageChange"></Paginator>
        </div>
        
        <!-- <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true" showGridlines
        >
        <template #empty>
        <b style="text-align:center">No records found.</b>
      </template>
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0"><b> Manage Vehicle Master</b></h5>
              
              <div>
            
              <Button icon="pi pi-refresh" v-tooltip.bottom="'Refresh'" @click="search(2)" />&nbsp;
              <Button  class="ml-2" 
              v-tooltip.bottom="'Generate QR'" @click="GenerateQr" >Generate QR</Button>
            </div>         
             
            </div><div style="text-align:right;font-weight:bold"><span>Total Vehicles:</span>{{totalRecords}}</div>
          </template>

          
          <Column header="Sr No" style="min-width: 5rem;text-align: center;">
            <template #body="{ index}">
            <span v-if="page_no==1">{{ +index+ +1 }}</span>
              <span v-else>{{(+index+1)+limit*(page_no-1)}}</span>
            </template>
          </Column>

          <Column header="QR" headerStyle="min-width:5rem;">
            <template #body="slotProps">
             <Button
                icon="pi pi-bookmark"
                class="p-button-rounded p-button-primary mt-2"
                v-tooltip.bottom="'QR Code'"
                @click="showQr(slotProps.data)"
              />
             
            </template>
          </Column>
         
          <Column header="Status" style="min-width: 8rem ;text-align: center;" :field="columns[14]" >
            <template #body="{ data }">
              <span v-if="data.status=='Active' ||data.status=='active'"><badge :value=data.status severity="success"></badge></span>
            <span v-else-if="data.status=='InActive' ||data.status=='In Active'"><badge :value=data.status severity="warning"></badge></span>
            <span v-else-if="data.status=='Delete' ||data.status=='Deleted'"><badge :value=data.status severity="danger"></badge></span>
            <span v-else>{{data.status}}</span>
            </template>
          </Column>

          
          <Column header="Image" :field="columns[9]" style="text-align:center;">
            <template #body="{ data }">
              <img  :src="data.photos[0]" 
                    :alt="data.photos[0]" 
                    v-if="data.photos && data.photos.length>0" 
                    class="shadow-2"
                    width="50">
              <img  v-else
                    src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                    class="shadow-2"
                    width="50"
            />
            </template>
          </Column>
          <Column header="Registration Number" :field="columns[9]" style="text-align:right;">
            <template #body="{ data }">
              {{ data.registration_number }}
            </template>
          </Column>
          <Column
            header="RC Mobile Number"
            style="min-width: 5rem"
            >
            <template #body="{ data }">
              {{ data.mobile_number_rc }}
            </template>
          </Column>
                   
          <Column header="Owner Name" :field="columns[10]" style="min-width: 10rem;">
            <template #body="{ data }">
              {{ data.owner_name }}
            </template>
          </Column>
          <Column header="Owner Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.owner_mobile_number }}
            </template>
          </Column>
          <Column header="Driver Name" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_name }}
            </template>
          </Column>
          <Column header="Driver Mobile Number" :field="columns[10]">
            <template #body="{ data }">
              {{ data.driver_mobile_number }}
            </template>
          </Column>
          <Column header="vehicle Type" :field="columns[10]" style="min-width: 10rem;">
            <template #body="{ data }">
              {{ data.vehicle_type }}
            </template>
          </Column>
          <Column header="Action" headerStyle="min-width:15rem;">
            <template #body="slotProps">
              <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  v-tooltip.bottom="'View'"
                  @click="viewProduct(slotProps.data)"
                />
              <Button
                icon="pi pi-pencil"
                v-tooltip.bottom="'Edit'"
                class="p-button-rounded p-button-primary mr-2"
                @click="editProduct(slotProps.data)"
              />
              
              <Button
                icon="pi pi-trash"
                v-tooltip.bottom="'Delete'"
                class="p-button-rounded p-button-warning mr-2"
                @click="confirmDeleteProduct(slotProps.data)"
              />
              
            </template>
          </Column>

          
        </DataTable> -->

        <Sidebar
          v-model:visible="productDialog"
          :baseZIndex="1000"
          position="full"
        >
          <div class="col-12">
            <div class="card">
              <h5>User Form</h5>
              <hr />
              <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-2">
                  <label for="status">Status</label>
                  <Dropdown
                    id="status"
                    v-model="selectstatus"
                    :options="dropdownItems"
                    :value="dropdownItems.value"
                    optionLabel="name"
                    placeholder="Select One"
                    :class="{ 'p-invalid': submitted && !selectstatus }"
                    required="true"
                  ></Dropdown>
                </div>

                <div class="field col-12 md:col-2">
                  <label for="firsT_NAME">First Name</label>
                  <InputText
                    id="firsT_NAME"
                    type="text"
                    v-model.trim="product.firsT_NAME"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.firsT_NAME }"
                  />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="middeL_NAME">Middle Name</label>
                  <InputText
                    id="middeL_NAME"
                    type="text"
                    v-model.trim="product.middeL_NAME"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.middeL_NAME }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="surname">Lastname</label>

                  <InputText
                    id="surname"
                    type="text"
                    v-model.trim="product.surname"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.surname }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="aadhaR_CARD">Adhar No</label>
                  <InputText
                    id="aadhaR_CARD"
                    type="number"
                    v-model.trim="product.aadhaR_CARD"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.aadhaR_CARD }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="state">State</label>
                  <InputText
                    id="state"
                    type="text"
                    v-model.trim="product.state"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.state }"
                  />
                </div>

                <div class="field col-12 md:col-2">
                  <label for="disrtict">District</label>
                  <InputText
                    id="disrtict"
                    type="text"
                    v-model.trim="product.disrtict"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.disrtict }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="taluka">Taluka</label>
                  <InputText
                    id="taluka"
                    type="text"
                    v-model.trim="product.taluka"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.taluka }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="citY_VILLAGE">City/Village</label>
                  <InputText
                    id="citY_VILLAGE"
                    type="text"
                    v-model.trim="product.citY_VILLAGE"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.citY_VILLAGE }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="pincode">Pincode</label>
                  <InputText
                    id="pincode"
                    type="number"
                    v-model.trim="product.pincode"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.pincode }"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="card">
              <div class="p-fluid formgrid grid">
                <div class="field col-12">
                  <label for="address">Address</label>

                  <Textarea
                    id="address"
                    type="text"
                    v-model.trim="product.address"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.address }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="mobile">Mobile No</label>
                  <InputText
                    id="mobile"
                    type="number"
                    v-model.trim="product.mobile"
                    required="true"
                    autofocus
                    :class="{
                      'p-invalid': submitted && !product.mobile,
                    }"
                  />
                </div>
                <div class="field col-12 md:col-2">
                  <label for="email">Email</label>
                  <InputText
                    id="email"
                    type="text"
                    v-model.trim="product.email"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !product.email }"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 md:col-6">
            <Button
              v-if="product.admiN_ID"
              label="UPDATE"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <Button
              v-else
              label="ADD"
              icon="pi pi-check"
              class="p-button-success mr-1 mb-1"
              @click="adduser"
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger mr-1 mb-1"
              @click="visibleFull = false"
            />
          </div>
        </Sidebar>

        <Dialog
          v-model:visible="productDialog_old"
          :style="{ width: '450px', width: '450px' }"
          header="Year Details"
          :modal="true"
          class="p-fluid"
        >
          <div class="grid">
            <div class="col-12 md:col-12">
              <div class="field">
                <!-- <img
            :src="'images/product/shoes.jpg'"
            :alt="product.image"
            width="150"
            class="mt-0 mx-auto mb-5 block shadow-2"
          /> -->
              </div>
              <div class="field">
                <label for="enrollmenT_YEAR"
                  >Enrollement Year <i style="color: green">(eg.2022)</i></label
                >
                <InputText
                  id="enrollmenT_YEAR"
                  v-model.trim="product.enrollmenT_YEAR"
                  required="true"
                  autofocus
                  :class="{
                    'p-invalid': submitted && !product.enrollmenT_YEAR,
                  }"
                />
              </div>
              <div class="field">
                <label for="exaM_YEAR"
                  >Exam Year <i style="color: green">(eg.2022-23)</i></label
                >
                <InputText
                  id="exaM_YEAR"
                  v-model.trim="product.exaM_YEAR"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.exaM_YEAR }"
                />
                <!-- <small class="p-invalid" v-if="submitted && !product.name"
                  >Name is required.</small
                > -->
              </div>
              <!-- <div class="field">
                <label for="description">Description</label>
                <Textarea
                  id="description"
                  v-model.trim="product.description"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.description }"
                />
              </div>
              <div class="field">
                <label for="link">Video Link</label>
                <InputText
                  id="link"
                  v-model.trim="product.videolink"
                  required="true"
                  autofocus
                  :class="{ 'p-invalid': submitted && !product.link }"
                />
              </div>
              
              <div class="field">
                <label for="status">Type</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus"
                  :options="dropdownItems"
                  :value="dropdownItems.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus }"
                  required="true"
                ></Dropdown>
              </div>

              <div class="field">
                <label for="status">Status</label>

                <Dropdown
                  id="state"
                  v-model="selectstatus2"
                  :options="dropdownItems2"
                  :value="dropdownItems2.value"
                  optionLabel="name"
                  placeholder="Select One"
                  :class="{ 'p-invalid': submitted && !selectstatus2 }"
                  required="true"
                ></Dropdown>
              </div> -->
            </div>
            <div class="col-12 md:col-6">
              <!-- <Button
                v-if="product.mjyeaR_ID"
                label="UPDATE"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
               
              />
              <Button
                v-else
                label="ADD"
                icon="pi pi-check"
                class="p-button-success mr-1 mb-1"
                @click="Addyear"
              /> -->
            </div>
            <div class="col-12 md:col-6">
              <Button
                label="Cancel"
                icon="pi pi-times"
                class="p-button-danger mr-1 mb-1"
                @click="productDialog = false"
              />
            </div>
          </div>
        </Dialog>
        <Dialog
          v-model:visible="qrCodetDialog"
          :style="{ width: '450px' }"
          header="QR Code"
          :modal="true"
        >
        <div style="text-align:right">
          <Button  icon="pi pi-print" @click="printQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
          <Button  icon="pi pi-download" @click="downloadQr()" class="p-button-rounded p-button-info mr-2 mb-2" />
        </div>
				<br>
        <div>
              <qrcode-vue id="qrprint" type="image/png" style="width:100%"  :value="qrcodevalue" size="450" level="H" />
        </div>
        </Dialog>
        <Dialog
          v-model:visible="deleteProductDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete <b>{{ product.firsT_NAME }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              
              @click="deleteuser"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteProductsDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="product"
              >Are you sure you want to delete the selected products?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteProductsDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedProducts"
            />
          </template>
        </Dialog>
        <Dialog v-model:visible="generateQRDialog" :style="{ width: '650px' }" header="Generate QR" :modal="true">
          <div class="p-fluid formgrid grid" style="margin-top: 10%">
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <Dropdown  id="state" filter
                v-model="client_id_search" :options="client_id_dropdown" optionLabel="name" :optionValue="code"
                ></Dropdown>
              <label>Select Client</label>
            </span>
          </div>
            
            <div class="field col-12 md:col-6">
            <span class="p-float-label">
              <InputText format="text" v-model="qrCount"> </InputText>
              <label>Total no of QR</label>
            </span>
          </div>
          
            </div>
          <template #footer>
            <Button label="Generate QR" class="p-button-text " style="background-color: 
#d6ebf9; border: 1px solid #246D9F;" @click="generate_QR" ></Button>
            <!-- <label>Generate QR</label> -->
            <!-- <Button  class="ml-2" style="background-color: #349CE4; border: 1px solid #349CE4;"
            v-tooltip.bottom="'Generate QR'" @click="generate_QR" >Generate QR</Button> -->
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import QrcodeVue from 'qrcode.vue'
import BreadcrumbService from "../service/BreadcrumbService";


//import FormNewsMaster from "@/components/FormNewsMaster";


// import axios from "axios";
import apis from "@/apis";
import axios from "axios";

export default {
  data() {
    return {
      perPageOptions: [6, 12, 18, 1000],
      rowsPerPage: 6,
      rows: 6,
      currentPage: 1,
      layout: 'grid',
      dataviewValue:null,
      generateQRDialog:false,
      qrCount:'',
      veh_reg_no:'',
      vehicle_status:'',
      vehicle_status_dropdown:[],
      client_group_ids:'',
      client_id_dropdown: [],
      client_id_search:'',
      reg_number:'',
      mob_number:'',
      owner_driver_name:'',
      vehicle_dropdownItems: [],
      vehicle_dropdownItem: '',
      district_dropdownItem:null,
      district_dropdownItems:[],
      block_dropdownItem:null,
      block_dropdownItems:[],
      panchayat_dropdownItem:null,
      panchayat_dropdownItems:[],
      village_dropdownItem:null,
      village_dropdownItems:[],
      showFirstFilter: false,
      page_no:1,
      qrcodevalue:"123444",
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      qrCodetDialog:false,
      file_attachment: "",
      // dropdownItems: [
      //   { name: "Motivational", value: "Motivational" },
      //   { name: "Interview", value: "Interview" },
      // ],
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      products: null,
      user_key:"",
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      selectstatus: { name: "", value: "" },
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 6,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService : null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.user_key=localStorage.getItem("user_key");
    this.initFilters();
    this.get_client_list();
    this.getDistrictData();
    this.showFirstFilter = false;
    this.get_vehicle_type_master();
    this.get_vehicle_status_master();
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.vehiclemaster()
    this.breadcrumbHome=Breadcrum_data.home;
    this.breadcrumbItems=Breadcrum_data.items;
    this.client_group_ids=localStorage.getItem('client_group_ids');
  },
  async mounted() {
     //this.productService.getProducts().then(data => this.dataviewValue = data);
    this.id = this.$route.params.id;

    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    lock_Unlock(data,flag)
    {
        var id = data._id;
        var type="";
        if(flag==1) 
        {
          type='UnLock';
        }
        else if(flag==2)
        {
          type='Lock';
        }

        var data = {
          "id":id,
          "type":type
        }
        this.isLoadingModel = true;
        var promises = apis.lockunlockVehicle(data);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.$swal.fire(response.data.data.message);
            this.get_list();
            this.get_count();
          });
    },
    async onPageChange(event) {
      console.log("event",event);
      
      this.currentPage = event.page + 1;
      this.page_no = event.page + 1;
      this.rows = event.rows;
      this.limit = event.rows;
      await this.get_list();
      await this.get_count();
    },
    generate_QR()
    {
        if (this.qrCount==0 || this.qrCount=='') 
        {
          this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please enter total no of QR",
          life: 3000,
        });
        return false;
        }
       
     
        
        var client_id = this.client_id_search.value ? this.client_id_search.value : localStorage.getItem("client_id");

        var data = {
          "qrcount":this.qrCount,
          "user_id":localStorage.getItem("id"),
          "client_id":client_id
        }
        this.isLoadingModel = true;
        var promises = apis.generateqr(data);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            if (response.data.data.status==true) {
              this.generateQRDialog = false;
              this.$swal(response.data.data.message);
              this.get_list();
              this.get_count();
            } else {
              
              this.$swal(response.data.data.message);
              
            }
            
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.generateQRDialog = false;

            this.$swal.fire(response.data.data.message);
            this.get_list();
            this.get_count();
          });



    },
    GenerateQr()
    {
      this.product = {};
      this.submitted = false;
      this.qrCount='';
      this.client_id_search="";
      this.generateQRDialog = true;
    },
    get_vehicle_type_master() {
      var client_id=this.client_id_search.code?this.client_id_search.code:localStorage.getItem("client_id");
            // this.loading = true;
            var data = {
                client_id:client_id
                
            };
            var promise = apis.vehicle_type_master(data);
            promise.then((response) => {
                // this.loading = false;
                
                if (response.data.data) {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].name, value: response.data.data[x].name
                        });

                    }
                    this.vehicle_dropdownItem = '';
                    this.vehicle_dropdownItems = temp_data;
                }

            });
        },
    isNumber(evt) {  
      const charCode = evt.which ? evt.which : evt.keyCode;  
      if (  
        charCode > 31 &&  (charCode < 48 || charCode > 57) &&  charCode !== 32 &&  (charCode > 65 || charCode < 90)) {  
        evt.preventDefault();  
      }  
    },

    getDistrictData() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
        count: false,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.district_dropdownItem = null;
          this.district_dropdownItems = temp_data;
          if (
            this.district_dropdownItems.length > 0 &&
            localStorage.getItem("district_id")
          ) {
            var data = this.district_dropdownItems;
            var temp_district_id = this.string_to_array_converter(
              localStorage.getItem("district_id")
            );
            const valuesFromArr1 = new Set(temp_district_id);
            const filteredArr2 = data.filter((obj) =>
              valuesFromArr1.has(obj.value)
            );
            this.district_dropdownItems = filteredArr2;
          }
        }
      });
    },
    
    getBlockData()
    {
      this.block_dropdownItem=null;
      this.block_dropdownItems=[];
      var district_code=[];

      if(this.district_dropdownItem)
      {
        for(var i=0; i<this.district_dropdownItem.length; i++)
        {
          district_code.push(this.district_dropdownItem[i].value)
        }
      }
      this.set_loading=true;
        var data={
          district_code:district_code,
          count:false,
        };
      var promise=apis.getBlockData(data);
      promise.then((response)=>{
        this.set_loading=false;
        if(response.data.data)
        {
          var temp_data=[];
          for(var j=0; j<response.data.data.length; j++)
          {
           temp_data.push({
            name:response.data.data[j].name,
            value:response.data.data[j].code,
           });
          }
          this.block_dropdownItem=null;
          this.block_dropdownItems=temp_data;
        }
      });      
    },

    getPanchayatData()
    {
      this.panchayat_dropdownItem=null;
      this.panchayat_dropdownItems=[];

      var district_code=[];
      var block_code=[];

      if(this.district_dropdownItem)
      {
        for(var j=0; j<this.district_dropdownItem.length; j++)
        {
          district_code.push(this.district_dropdownItem[j].value);
        }
      }
      if(this.block_dropdownItem)
      {
        for(var i=0; i<this.block_dropdownItem.length; i++)
        {
          block_code.push(this.block_dropdownItem[i].value);
        }
      }
      this.set_loading=true;

      var data={
        district_code:district_code,
        block_code:block_code,
        count:false,
      }
      var promise=apis.getPanchayatData(data);
      var temp_data=[];
      promise.then((response)=>{
        if(response.data.data)
        {
          for(var k=0; k<response.data.data.length; k++)
          {
            temp_data.push({
              name:response.data.data[k]["Local Body Name"],
              value:response.data.data[k]["Local Body Code"],
            })
          }
          this.panchayat_dropdownItem=null;
          this.panchayat_dropdownItems=temp_data;
        }
      });      
    },

    getVillageData(search)
    {
      this.village_dropdownItem=null;
      this.village_dropdownItems=[];
      var district_code=[];
      var block_code=[];
      var panchayat_code=[];
      this.set_loading=true;

      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var b = 0; b < this.panchayat_dropdownItem.length; b++) {
          panchayat_code.push(this.panchayat_dropdownItem[b].value);
        }
      }

      var data={
        "count": false,
        "page_no": 1,
        "limit": 10,
        district_code:district_code,
        block_code:block_code,
        panchayat_code: panchayat_code,
      }
      if(search!=1){
        data.search_name=search.value;
      }
      var temp_data=[];
      var promise=apis.getVillageData(data);
      promise.then((response)=>{
        if(response.data.data)
        {
          for(var l=0; l<response.data.data.length; l++)
          {
            temp_data.push({
              name:response.data.data[l].village_name,
              value:response.data.data[l].code,
            });
          }
          this.village_dropdownItem=null,
          this.village_dropdownItems=temp_data;
        }
      });
    },


    show_filter() {
      this.showFirstFilter = true;
    },

    reset()
    {
      this.client_id_search='';
          this.reg_number='';
          this.mob_number='';
          this.owner_driver_name='';
          this.vehicle_dropdownItem = '';
          this.showFirstFilter = false;
          this.get_list();
          this.get_count();
    },

    async search(count)
      { 
        // count==2?this.client_id_search='':'';
        // count==2?this.reg_number='':'';
        // count==2?this.mob_number='':'';
        // count==2?this.vehicle_dropdownItem = '':'';
        if (count==2) 
        { 
          this.client_id_search='';
          this.reg_number='';
          this.mob_number='';
          this.owner_driver_name='';
          this.vehicle_dropdownItem = '';
          this.showFirstFilter = false;
          await this.getDistrictData();
          await this.getBlockData();
          await this.getPanchayatData();
          await this.getVillageData();
          this.get_vehicle_type_master();
        
        }
        await this.get_list();
        await this.get_count();
      },
    get_client_list()
    { 
      const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      var data = { count: false,};
      var promise = apis.getclientist(data);
        promise.then((response) => {
          // if(response.data.data){
          // response.data.data
          //   .filter(item => item.client_name)
          //   .map(item => this.client_id_dropdown.push({ name: item.client_name, code: item._id }));
          // }
          var temp_data = [];

                    for (let x = 0; x < response.data.data.length; x++) {
                        const clientData = response.data.data[x];
                        
                        if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                            temp_data.push({ name: clientData.client_name, value: clientData._id });
                        }
                    }

                    this.client_id_dropdown = temp_data;
        });
    },
    async viewProduct(product)
      {
  
        // var data=[product]
        console.log(JSON.stringify(product));
        await localStorage.setItem('saveprofilevehicledata',JSON.stringify(product));
        this.$router.push({name:"vehicleprofile"});
      },
    async downloadQr()
    {
      var canvas = await document.getElementById("qrprint");
      var anchor = document.createElement("a");
      anchor.href = canvas.toDataURL("image/png");
      anchor.download = "QrIMAGE.PNG";
      anchor.click();
    },
    async printQr()
    {
         var dataUrl = await document.getElementById('qrprint').toDataURL(); //attempt to save base64 string to server using this var  
    var windowContent = await '<!DOCTYPE html>';
    windowContent += await '<html>'
    windowContent += await '<head><title>'+this.veh_reg_no+'</title></head>';
    windowContent +=await '<body>'
    windowContent +=await '<h4> Vehicle Number: '+this.veh_reg_no+'</h4><br>';
    windowContent += await '<img src="' + dataUrl + '">';
    windowContent +=await '</body>';
    windowContent +=await '</html>';
    var printWin = window.open('','','width=900,height=600,align=center');
    // alert(windowContent);
    await printWin.document.open();
    await printWin.document.write(await windowContent);
    printWin.document.close();
    printWin.focus();
    printWin.print();
    // printWin.close();
    },
    //a simple date formatting function
    dateFormat(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
                
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);

        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);

                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return date+"-"+month+"-"+year;
                }
            }
        }
        else {
           return "";
        }
    },
    handleFileUpload() {
      this.file_attachment = this.$refs.file_attachment.files[0];

      //alert(this.$refs.file_attachment.files[0].name);
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
    //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var client_id=this.client_id_search.code?this.client_id_search.code:localStorage.getItem("client_id");
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
      //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
        if(this.vehicle_status && this.vehicle_status.length>0)
        {
          var vehicle_status = []
              for (let x = 0; x < this.vehicle_status.length; x++) {
                vehicle_status.push(this.vehicle_status[x].value);
                
              }
        }

        var block_code = [];
        var district_code = [];
        var village_code = [];
        var panchayat_code=[];
        if (this.block_dropdownItem) {
          for (var c = 0; c < this.block_dropdownItem.length; c++) {
            block_code.push(this.block_dropdownItem[c].value);
          }
        }
        if (this.district_dropdownItem) {
          for (var d = 0; d < this.district_dropdownItem.length; d++) {
            district_code.push(this.district_dropdownItem[d].value);
          }
        }
        if (this.panchayat_dropdownItem) {
          for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
            panchayat_code.push(this.panchayat_dropdownItem[f].value);
          }
        }
        if (this.village_dropdownItem) {
          for (var e = 0; e < this.village_dropdownItem.length; e++) {
            village_code.push(this.village_dropdownItem[e].value);
          }
        }
      var data = {
        // id: localStorage.getItem("id"),
        count: true,
        client_id:client_id,
        registration_number:this.reg_number,
        mobile_number:this.mob_number,
        vehicle_type:this.vehicle_dropdownItem.value,
        owner_driver_name:this.owner_driver_name,
        district_code: district_code,
        block_code: block_code,
        village_code: village_code,
        panchayat_code: panchayat_code,
        "client_group_ids":client_group_ids,
        "vehicle_status":vehicle_status
        
      };
      this.loading = true;
      var promise = apis.vehiclelist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });

      console.log(data);
    },
    get_list: function () {
      this.products =[];
      var client_id=this.client_id_search.code?this.client_id_search.code:localStorage.getItem("client_id");
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
      //var client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      if (this.client_id_search && this.client_id_search.length>0) 
        {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
        }
        if(this.vehicle_status && this.vehicle_status.length>0)
        {
          var vehicle_status = []
              for (let x = 0; x < this.vehicle_status.length; x++) {
                vehicle_status.push(this.vehicle_status[x].value);
                
              }
        }

        var block_code = [];
      var district_code = [];
      var village_code = [];
      var panchayat_code=[];
      if (this.block_dropdownItem) {
        for (var c = 0; c < this.block_dropdownItem.length; c++) {
          block_code.push(this.block_dropdownItem[c].value);
        }
      }
      if (this.district_dropdownItem) {
        for (var d = 0; d < this.district_dropdownItem.length; d++) {
          district_code.push(this.district_dropdownItem[d].value);
        }
      }
      if (this.panchayat_dropdownItem) {
        for (var f = 0; f < this.panchayat_dropdownItem.length; f++) {
          panchayat_code.push(this.panchayat_dropdownItem[f].value);
        }
      }
      if (this.village_dropdownItem) {
        for (var e = 0; e < this.village_dropdownItem.length; e++) {
          village_code.push(this.village_dropdownItem[e].value);
        }
      }
      var data = {
        // id: localStorage.getItem("id"),
        client_id:client_id,
        limit: this.limit,
        page_no: this.page_no,
        count: false,
        registration_number:this.reg_number,
        mobile_number:this.mob_number,
        vehicle_type:this.vehicle_dropdownItem.value,
        owner_driver_name:this.owner_driver_name,
        district_code: district_code,
        block_code: block_code,
        village_code: village_code,
        panchayat_code:panchayat_code,
        "client_group_ids":client_group_ids,
        "vehicle_status":vehicle_status
        //client_id: localStorage.getItem("client_id")?localStorage.getItem("client_id"):''
      };
      this.loading = true;
      var promise = apis.vehiclelist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });

      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      // this.productDialog = true;
      this.$router.push({name:"vehicle_add_track"});
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    async adduser() {
      this.submitted = true;
      if (!this.selectstatus.value) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Select Status",
          life: 3000,
        });
        return false;
      }
      if (!this.product.firsT_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter First Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.middeL_NAME) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Middle Name",
          life: 3000,
        });
        return false;
      }
      if (!this.product.surname) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter LastName",
          life: 3000,
        });
        return false;
      }
       if (!this.product.aadhaR_CARD) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Adhar No",
          life: 3000,
        });
        return false;
      }
      
      if (!this.product.state) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter State",
          life: 3000,
        });
        return false;
      }
      if (!this.product.disrtict) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter District",
          life: 3000,
        });
        return false;
      }
       if (!this.product.taluka) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Taluka",
          life: 3000,
        });
        return false;
      }
      if (!this.product.citY_VILLAGE) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter city/village",
          life: 3000,
        });
        return false;
      }
      if (!this.product.pincode) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter Pincode",
          life: 3000,
        });
        return false;
      }
      if (!this.product.address) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter address",
          life: 3000,
        });
        return false;
      }
      if (!this.product.mobile) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter mobile",
          life: 3000,
        });
        return false;
      }
      if (!this.product.email) {
        this.$toast.add({
          severity: "error",
          summary: "error",
          detail: "Please Enter email",
          life: 3000,
        });
        return false;
      }

      //edit
      if (this.product.admiN_ID) {
        var data = {
          Admin_id: this.product.admiN_ID,
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
        };
        this.isLoadingModel = true;
        var promise = apis.editusermaster(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
      //add-----------------------------------------------------------------------------------------------------------------
      else {
        var data1 = {
          firsT_NAME: this.product.firsT_NAME,
          middeL_NAME: this.product.middeL_NAME,
          surname: this.product.surname,
          address: this.product.address,
          state: this.product.state,
          disrtict: this.product.disrtict,
          taluka: this.product.taluka,
          citY_VILLAGE: this.product.citY_VILLAGE,
          mobile: parseInt(this.product.mobile),
          email: this.product.email,
          pincode: parseInt(this.product.pincode),
          aadhaR_CARD: parseInt(this.product.aadhaR_CARD),
          status: this.selectstatus.value,
          createD_BY: localStorage.getItem("full_name"),
        };
        this.isLoadingModel = true;
        var promises = apis.addusermaster(data1);
        promises
          .then((response) => {
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal(response.data.message);
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
            //console.log(error);
            this.isLoadingModel = false;
            this.productDialog = false;

            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }

      this.selectstatus = { name: "", value: "" };
      //  this.selectstatus2={name:"",value:""}
    },
    get_vehicle_status_master() 
    {
            var data = 
            {
               "count":false
            };
            var promise = apis.VehicleStatusMaster(data);
            promise.then((response) => {
               if (response.data.data) 
               {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({
                            name: response.data.data[x].vehicle_status, value: response.data.data[x].vehicle_status
                        });

                    }
                    this.vehicle_status = '';
                    this.vehicle_status_dropdown = temp_data;
                }

            });
        },
    saveProduct() {
      this.submitted = true;
      if (this.product.name.trim()) {
        if (this.product.id) {
          this.product.inventoryStatus = this.product.inventoryStatus.value
            ? this.product.inventoryStatus.value
            : this.product.inventoryStatus;
          this.products[this.findIndexById(this.product.id)] = this.product;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Updated",
            life: 3000,
          });
        } else {
          this.product.id = this.createId();
          this.product.code = this.createId();
          this.product.image = "product-placeholder.svg";
          this.product.inventoryStatus = this.product.inventoryStatus
            ? this.product.inventoryStatus.value
            : "INSTOCK";
          this.products.push(this.product);
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Product Created",
            life: 3000,
          });
        }
        this.productDialog = false;
        this.product = {};
      }
    },
  async  editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      //this.productDialog = true;
      this.selectstatus.value = this.product.status;
      this.selectstatus.name = this.product.status;

        await localStorage.setItem('savevehicledata','');
        await localStorage.setItem('savevehicledata',JSON.stringify(product));
        this.$router.push({name:"vehicle_edit"});
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    showQr(product) {
      // this.qrcodevalue='vehicle_id-'+product._id;
      this.qrcodevalue=product.uicode
      this.veh_reg_no=product.registration_number;
      this.qrCodetDialog=true;
      // this.product = product;
      // this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },

    deleteuser() {
      if (this.product._id) {
        var data = {
          id: this.product._id,
          user_id:localStorage.getItem("id")
        };
        this.isLoadingModel = true;
        var promise = apis.deletevehicle(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete vehicle");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    
  async  exportCSV() {
      this.limit=this.totalRecords;
      this.get_list();
     await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {downloadExcel: JsonExcel,QrcodeVue},
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";


.image-wrapper {
  height: 100px;
}

.card-hover:hover {
  transform: scale(1.04);
  transition: transform 0.5s;
}
</style>


